import { useState, useEffect, useContext } from 'react';
import Loader from '../Common/Loader';
import axios from 'axios';
import { LayoutContext } from '../../Context/LayoutContext';
import { API_URL } from '../../Config/constant';
import toast, { Toaster } from 'react-hot-toast';

const validateImageSize = (file, callback) => {
  const img = new Image();
  let objectUrl;
  if (typeof file === 'string') {
    objectUrl = file;
  } else {
    objectUrl = URL.createObjectURL(file);
  }
  img.src = objectUrl;
  img.onload = () => {
    if (typeof file !== 'string') {
      URL.revokeObjectURL(objectUrl);
    }
    if (img.width <= 1920 && img.height <= 1280 && img.width >= 1366 && img.height >= 768) {
      callback(true);
    } else {
      toast.error('Image must be between 1366x768 and 1920x1280 pixels.');
      callback(false);
    }
  };
};

export default function Carousal() {
  const [loading, setLoading] = useState(false);
  const [carousels, setCarousels] = useState([]);
  const { apiToken } = useContext(LayoutContext);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [newCarousel, setNewCarousel] = useState({
    title: '',
    description: '',
    image: null,
  });
  const [currentCarousel, setCurrentCarousel] = useState(null);

  useEffect(() => {
    if (apiToken) {
      fetchCarousels();
    }
  }, [apiToken]);

  const fetchCarousels = () => {
    setLoading(true);
    axios
      .post(
        `${API_URL}api/carousel/list`,
        {},
        {
          headers: { Authorization: `Bearer ${apiToken}` },
        }
      )
      .then((response) => {
        const { data } = response.data;
        setCarousels(data);
      })
      .catch((error) => {
        console.error('There was an error fetching the carousel data!', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleAdd = () => {
    validateImageSize(newCarousel.image, (isValid) => {
      if (!isValid) return;
      setLoading(true);
      const formData = new FormData();
      formData.append('title', newCarousel.title);
      formData.append('description', newCarousel.description);
      formData.append('image', newCarousel.image);

      axios
        .post(`${API_URL}api/carousel/add`, formData, {
          headers: {
            Authorization: `Bearer ${apiToken}`,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          const { message } = response.data;
          fetchCarousels();
          toast.success(message || 'Carousel added successfully!');
          setAddModalVisible(false);
        })
        .catch((error) => {
          const { message } = error.response.data;
          console.error('There was an error adding the carousel!', error);
          toast.error(message || 'Failed to add carousel.');
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const handleEdit = (id) => {
    const carousel = carousels.find((c) => c.id === id);
    setCurrentCarousel(carousel);
    setEditModalVisible(true);
  };

  const handleUpdate = () => {
    validateImageSize(currentCarousel.image, (isValid) => {
      if (!isValid) return;
      setLoading(true);
      const formData = new FormData();
      formData.append('title', currentCarousel.title);
      formData.append('description', currentCarousel.description);
      if (typeof currentCarousel.image !== 'string') {
        formData.append('image', currentCarousel.image);
      }
      formData.append('status', currentCarousel.status);

      axios
        .post(`${API_URL}api/carousel/edit/${currentCarousel.id}`, formData, {
          headers: {
            Authorization: `Bearer ${apiToken}`,
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          const { message } = response.data;
          fetchCarousels();
          toast.success(message || 'Carousel updated successfully!');
          setEditModalVisible(false);
        })
        .catch((error) => {
          const { message } = error.response.data;
          console.error('There was an error updating the carousel!', error);
          toast.error(message || 'Failed to update carousel.');
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  const handleStatusToggle = (id) => {
    const carousel = carousels.find((c) => c.id === id);
    const newStatus = carousel.status === 1 ? 0 : 1;
    setLoading(true);
    axios
      .post(
        `${API_URL}api/carousel/update-status/${id}`,
        { status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${apiToken}`,
          },
        }
      )
      .then((response) => {
        const { message } = response.data;
        fetchCarousels();
        toast.success(message || 'Status updated successfully!');
      })
      .catch((error) => {
        const { message } = error.response.data;
        console.error('There was an error updating the status!', error);
        toast.error(message || 'Failed to update status.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = (id) => {
    setLoading(true);
    axios
      .post(
        `${API_URL}api/carousel/delete/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${apiToken}`,
          },
        }
      )
      .then((response) => {
        const { message } = response.data;
        fetchCarousels();
        toast.success(message || 'Carousel deleted successfully!');
      })
      .catch((error) => {
        const { message } = error.response.data;
        console.error('There was an error deleting the carousel!', error);
        toast.error(message || 'Failed to delete carousel.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <button
        className="btn btn-primary"
        onClick={() => setAddModalVisible(true)}
        style={{ marginBottom: '10px', padding: '13px' }}
      >
        Add Carousel
      </button>{' '}
      <div className="card ">
        {loading && <Loader />}
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table  custom-table  no-footer">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Image</th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th className="table-status-column">Action</th>
                </tr>
              </thead>
              <tbody>
                {carousels.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No carousel available
                    </td>
                  </tr>
                ) : (
                  carousels.map((carousel, index) => (
                    <tr key={carousel.id}>
                      <td>{index + 1}</td>
                      <td>
                        <img src={carousel.image} alt={carousel.title} width="50" />
                      </td>
                      <td>{carousel.title}</td>
                      <td>{carousel.description}</td>
                      <td>
                        <span
                          style={{
                            color: carousel.status === 1 ? 'green' : 'red',
                          }}
                        >
                          {carousel.status === 1 ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td className="table-status-column">
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => handleEdit(carousel.id)}
                          style={{ padding: '.25rem .5rem' }}
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          className="btn btn-warning btn-sm"
                          onClick={() => handleStatusToggle(carousel.id)}
                        >
                          <i className={`fas fa-${carousel.status === 1 ? 'times' : 'check'}`}></i>
                        </button>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(carousel.id)}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {editModalVisible && (
        <div className="customize_popup">
          <div
            className="modal fade show"
            style={{
              display: 'block',
              background: 'rgba(0, 0, 0, 0.5)',
            }}
            id="edit_carousel"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Edit Carousel
                  </h5>
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={() => setEditModalVisible(false)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="col-md-12 p-0">
                    <div className="form-group">
                      <label htmlFor="carouselTitle">Title</label>
                      <input
                        type="text"
                        id="carouselTitle"
                        className="form-control"
                        value={currentCarousel.title}
                        onChange={(e) =>
                          setCurrentCarousel({
                            ...currentCarousel,
                            title: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="carouselDescription">Description</label>
                      <input
                        type="text"
                        id="carouselDescription"
                        className="form-control"
                        value={currentCarousel.description}
                        onChange={(e) =>
                          setCurrentCarousel({
                            ...currentCarousel,
                            description: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="carouselImage">Image</label>
                      <input
                        type="file"
                        id="carouselImage"
                        className="form-control"
                        onChange={(e) =>
                          setCurrentCarousel({
                            ...currentCarousel,
                            image: e.target.files[0],
                          })
                        }
                      />
                      <small className="form-text text-muted">
                        Image must be between 1366x768 and 1920x1280 pixels.
                      </small>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-add" onClick={handleUpdate}>
                    Update
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setEditModalVisible(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {addModalVisible && (
        <div className="customize_popup">
          <div
            className="modal fade show"
            style={{
              display: 'block',
              background: 'rgba(0, 0, 0, 0.5)',
            }}
            id="add_carousel"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Add Carousel
                  </h5>
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={() => setAddModalVisible(false)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="col-md-12 p-0">
                    <div className="form-group">
                      <label htmlFor="carouselTitle">Title</label>
                      <input
                        type="text"
                        id="carouselTitle"
                        className="form-control"
                        value={newCarousel.title}
                        onChange={(e) =>
                          setNewCarousel({
                            ...newCarousel,
                            title: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="carouselDescription">Description</label>
                      <input
                        type="text"
                        id="carouselDescription"
                        className="form-control"
                        value={newCarousel.description}
                        onChange={(e) =>
                          setNewCarousel({
                            ...newCarousel,
                            description: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="carouselImage">Image</label>
                      <input
                        type="file"
                        id="carouselImage"
                        className="form-control"
                        onChange={(e) =>
                          setNewCarousel({
                            ...newCarousel,
                            image: e.target.files[0],
                          })
                        }
                      />
                      <small className="form-text text-muted">
                        Image must be between 1366x768 and 1920x1280 pixels.
                      </small>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-add" onClick={handleAdd}>
                    Add
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setAddModalVisible(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Toaster />
    </>
  );
}
